import { ApiProperty } from "@nestjs/swagger";

export class GradingMonitoringDTO {
    @ApiProperty()
    gradingMonitoringId: number;
    @ApiProperty()
    gradingInventoryId: number;
    @ApiProperty()
    typeOfProduct: string;
    @ApiProperty()
    headlessCount: number;
    @ApiProperty()
    qualityEval: string;
    @ApiProperty()
    icing: string;
    @ApiProperty()
    tempOfProduct: string;  
    @ApiProperty()
    chlorineLevel: number;
    @ApiProperty()
    gradesObtaine: number;
    @ApiProperty()
    observedCount: number;
    @ApiProperty()
    correctiveAction: string;
    @ApiProperty()
    signOfSupervisor: string;
    @ApiProperty()
    verificationByQC: string;
    @ApiProperty()
    createdAt: Date;
    @ApiProperty()
    createdUser: string | null;
    @ApiProperty()
    updatedAt: Date;
    @ApiProperty()
    updatedUser: string | null;
    @ApiProperty()
    versionFlag: number;

}